module.exports = __webpack_public_path__ + "static/img/5878_phase_function_Paper_PointsHejduk_Prediction.dc3234e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5878_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Tea2
// module chunks = 0